import { apiCall } from "../helpers/api";


export const countries = (params = {}) => (dispatch) => {
  params.path = params.path || "regions/countries";
  return dispatch(apiCall(params));
}